import type { SxProps, SystemStyleObject } from "@mui/system";
import type { ThemeV2 } from "../../util/types";

export const subParentContainer = (
  isLandScapeMode: boolean,
  primaryColor: string,
): SxProps => ({
  minHeight: "100%",
  ...(isLandScapeMode
    ? { border: "1px solid", borderRadius: "12px" }
    : { border: `1px solid ${primaryColor}`, borderRadius: "10px" }),
  boxShadow: 3,
  marginX: "20px",
  backgroundColor: "white",
  paddingY: 2,
  paddingX: 2,
});

export const textHighLighterContainer = (orientation: string): SxProps => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  ...(orientation === "landscape"
    ? { flexDirection: "row", justifyContent: "stretch" }
    : { flexDirection: "column", justifyContent: "center" }),
  gap: 2,
});

export const highlighterDiv = (theme: ThemeV2): SystemStyleObject => ({
  fontFamily: theme.tokens.typography.fontFamily,
  lineHeight: theme.tokens.typography.lineHeight.normal,
  outline: "none", // Remove default focus outline
  cursor: "pointer",
  padding: `${theme.tokens.spacing["2"]}px`,
});
